import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { ProductCreationRequest, ProductCreationRequestManipulationViewModel, RequestStateEnumProvider } from "./productCreationRequestManipulation-viewModel"

export class ProductCreationRequestManipulationView extends View<ProductCreationRequestManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-5A4EF3CB-4066-4A74-A870-6B5B5D14E029"
    }
    loadHtml(): string {
        let element = require('./productCreationRequestManipulation.html').default;
        let style = require('./productCreationRequestManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set requestStateEnumProvider(v: RequestStateEnumProvider) { this._requestStateEnumProvider = v; } public get requestStateEnumProvider(): RequestStateEnumProvider { return this._requestStateEnumProvider;} private _requestStateEnumProvider: RequestStateEnumProvider;
    public set productCreationRequests(v: ObservableArray<ProductCreationRequest>) { this._productCreationRequests = v; } public get productCreationRequests(): ObservableArray<ProductCreationRequest> { return this._productCreationRequests;} private _productCreationRequests: ObservableArray<ProductCreationRequest>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    public set selectAll(v: boolean) { this._selectAll = v; } public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    rejectSelected () {
        this.dataContext.rejectSelected(null);
    }
}
